"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.safeJSONParse = void 0;
var _log = require("./log");
var safeJSONParse = exports.safeJSONParse = function safeJSONParse(jsonString) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var json = defaultValue;
  try {
    json = JSON.parse(jsonString);
  } catch (e) {
    _log.logger.error(e);
  }
  return json;
};